import React from "react";

export default function PageNotFound(){
    return(
        <div>
            <h1>Page not found</h1>
        </div>
    )
}
